"use strict";

module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/is-symbol.js
// module id = 2574
// module chunks = 0